import { gql } from '@apollo/client';

const fetchEmployeeCountOptionsQuery = gql`
  query companyProfileCompanyEmployeeCountryNames {
    companyProfileCompanyEmployeeCountOptions {
      id
      labelSr
      labelEn
    }
  }
`;

const fetchCountriesQuery = gql`
  query companyProfileCountryNames {
    companyProfileCountries {
      id
      srName
      enName
    }
  }
`;

export { fetchCountriesQuery, fetchEmployeeCountOptionsQuery };
